<template>
  <div id="channel-page">
    <!-- loader component -->
    <loader-component v-if="!project_detail" />
    <!-- page field component -->
    <div class="row" v-else>
      <div class="col-12" v-if="$store.getters.user.role != 1">
        <page-header-component icon="bi bi-toggles2" title="Manage Channel" :hide-filter="true" />
      </div>
      <!-- media konvensional channel -->
      <div id="channel-medkon" class="px-gap" :class="project_detail.display_tipe == 2 ? 'col-md-12' : 'col-md-6'" v-if="
        project_detail.display_tipe == 2 || project_detail.display_tipe == 3
      ">
        <div class="bg-white rounded p-3 h-100 shade">
          <h6>
            Channel Media Konvensional
            <i class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'channelMedKonHelper' }"></i>
          </h6>
          <div ref="channelMedKonHelper" class="tooltip-content">
            <p>
              <b>Manage Channel</b> untuk proyek ini. Anda dapat mengaktifkan
              atau menonaktifkan channel yang digunakan untuk proyek ini.
            </p>
          </div>
          <p class="m-b-15">
            Berikut merupakan daftar channel atau sumber data yang akan
            dikumpulkan.
          </p>
          <!-- media tv toggle -->
          <div v-if="project_detail.tipe == 1" class="b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input v-model="status_media_tv" type="checkbox" :checked="project_detail.crawler.formed.tv_status == 1"
                id="pagesSwitchTv" @click="toggleChannel('media_tv')" />
              <label for="pagesSwitchTv" class="full-width">
                <i class="bi bi-tv" /> Media TV
              </label>
            </div>
          </div>
          <!-- media cetak toggle -->
          <div v-if="project_detail.tipe == 1" class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.formed.cetak_status == 1" id="pagesSwitchCetak"
                @click="toggleChannel('media_cetak')" />
              <label for="pagesSwitchCetak" class="full-width">
                <i class="bi bi-newspaper icon-media_cetak" /> Media Cetak
              </label>
            </div>
          </div>
          <!-- online news toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.google.news_status == 1" id="pagesSwitchNews"
                @click="toggleChannel('news')" />
              <label for="pagesSwitchNews" class="full-width">
                <i class="bi bi-globe-americas" /> Online News
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- media sosial channel -->
      <div id="channel-medsos" class="px-gap" :class="project_detail.display_tipe == 1 ? 'col-md-12' : 'col-md-6'" v-if="
        project_detail.display_tipe == 1 || project_detail.display_tipe == 3
      ">
        <div class="bg-white rounded p-3 h-100 shade">
          <h6>
            Channel Media Sosial
            <i class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'channelMedKonHelper' }"></i>
          </h6>
          <p class="m-b-15">
            Berikut merupakan daftar channel atau sumber data yang akan
            dikumpulkan.
          </p>
          <!-- twitter toggle -->
          <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.twitter.status == 1" id="pagesSwitchTwitter"
                @click="toggleChannel('twitter')" />
              <label for="pagesSwitchTwitter" class="full-width">
                <i class="bi bi-twitter" /> Twitter
              </label>
            </div>
          </div>
          <!-- facebook toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.facebook.status == 1" id="pagesSwitchFacebook"
                @click="toggleChannel('facebook')" />
              <label for="pagesSwitchFacebook" class="full-width">
                <i class="bi bi-facebook" /> Facebook
              </label>
            </div>
          </div>
          <!-- instagram toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.instagram.status == 1" id="pagesSwitchInstagram"
                @click="toggleChannel('instagram')" />
              <label for="pagesSwitchInstagram" class="full-width">
                <i class="bi bi-instagram" /> Instagram
              </label>
            </div>
          </div>
          <!-- tiktok toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.tiktok.status == 1" id="pagesSwitchTiktok"
                @click="toggleChannel('tiktok')" />
              <label for="pagesSwitchTiktok" class="full-width">
                <i class="bi bi-tiktok" /> Tiktok
              </label>
            </div>
          </div>
          <!-- youtube toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.youtube.status == 1" id="pagesSwitchYoutube"
                @click="toggleChannel('youtube')" />
              <label for="pagesSwitchYoutube" class="full-width">
                <i class="bi bi-youtube" /> Youtube
              </label>
            </div>
          </div>
          <!-- linkedin toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.linkedin.status == 1" id="pagesSwitchLinkedin"
                @click="toggleChannel('linkedin')" />
              <label for="pagesSwitchLinkedin" class="full-width">
                <i class="bi bi-linkedin" /> Linkedin
              </label>
            </div>
          </div>
          <!-- forum toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.google.forum_status == 1" id="pagesSwitchForum"
                @click="toggleChannel('forum')" />
              <label for="pagesSwitchForum" class="full-width">
                <i class="bi bi-chat-dots-fill" /> Forum
              </label>
            </div>
          </div>
          <!-- blog toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.google.blog_status == 1" id="pagesSwitchBlog"
                @click="toggleChannel('blog')" />
              <label for="pagesSwitchBlog" class="full-width">
                <i class="bi bi-rss" /> Blog
              </label>
            </div>
          </div>
          <!-- review apps toggle -->
          <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
            <div class="form-check switch switch-lg complete full-width right d-flex m-b-0">
              <input type="checkbox" :checked="project_detail.crawler.review &&
                project_detail.crawler.review.status == 1
                " id="pagesSwitchReviewApps" @click="toggleChannel('review')" />
              <label for="pagesSwitchReviewApps" class="full-width">
                <i class="bi bi-phone" /> Review Aplikasi
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- tour -->
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import loader_component from "@/views/components/loader.vue";
import notif from "@/assets/js/notif.js";

export default {
  name: "Channel",
  title: "Settings Channel | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "loader-component": loader_component,
  },
  data() {
    return {
      tour_steps: [],
      project_detail: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      table: null,
      is_loading_filter: false,
      is_loading_media: false,
      medkon_filter: {
        news: [],
        media_cetak: [],
      },
      selected_media: {
        news: [],
        media_cetak: [],
      },
      status_media_tv: false,
      media_tv_type: {
        berita: true,
        iklan: true,
        running_text: true,
      },
      media_online_list: [],
      total_medkon_list: {
        news: 0,
        media_cetak: 0,
      },
      show_media: {
        news: [],
        media_cetak: [],
      },
      q: {
        news: null,
        media_cetak: null,
      },
      active_tab: {
        news: "all",
        media_cetak: "all",
      },
      active_filter: {
        news: "all",
        media_cetak: "all",
      },
      pagenumber: {
        news: 1,
        media_cetak: 1,
      },
    };
  },
  methods: {
    getChannelStatus: function() {
      this.is_loading_filter = true;
      let api =
        process.env.VUE_APP_API_URL + "project-detail-full/" + this.id_project;
      this.medkon_filter.news = [];
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.project_detail = response.data.project_detail;
            if ("jenis_data_tv" in this.project_detail.crawler.formed) {
              this.media_tv_type.berita =
                this.project_detail.crawler.formed.jenis_data_tv
                  .berita_status == 1
                  ? true
                  : false;
              this.media_tv_type.iklan =
                this.project_detail.crawler.formed.jenis_data_tv.iklan_status ==
                1
                  ? true
                  : false;
              this.media_tv_type.running_text =
                this.project_detail.crawler.formed.jenis_data_tv
                  .running_text_status == 1
                  ? true
                  : false;
            }
            if (this.project_detail.crawler.formed.tv_status == 1) {
              this.status_media_tv = true;
            } else {
              this.status_media_tv = false;
            }
            if ("filters" in this.project_detail) {
              if ("medkon" in this.project_detail["filters"]) {
                if ("news" in this.project_detail["filters"]["medkon"]) {
                  this.medkon_filter.news = this.project_detail["filters"][
                    "medkon"
                  ]["news"];
                  if (this.medkon_filter.news.length > 0) {
                    this.active_filter.news = "custom";
                    this.active_tab.news = "custom";
                  } else {
                    this.active_filter.news = "all";
                    this.active_tab.news = "all";
                  }
                }

                if ("media_cetak" in this.project_detail["filters"]["medkon"]) {
                  this.medkon_filter.media_cetak = this.project_detail[
                    "filters"
                  ]["medkon"]["media_cetak"];
                  if (this.medkon_filter.media_cetak.length > 0) {
                    this.active_filter.media_cetak = "custom";
                    this.active_tab.media_cetak = "custom";
                  } else {
                    this.active_filter.media_cetak = "all";
                    this.active_tab.media_cetak = "all";
                  }
                }
              }
            }
          } else {
            this.project_detail = {};
          }
        })
        .catch(function(err) {
          console.log(err);
          this.project_detail = {};
        })
        .finally(() => {
          this.is_loading_filter = false;
        });
    },
    toggleChannel: function(source) {
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: this.id_project,
        source: source,
        value: toggle,
      };

      let api = process.env.VUE_APP_API_URL + "source-toggle";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            if (this.isAdmin) {
              this.$store.dispatch(
                "change_channel",
                this.$store.getters.user.id_project
              );
            }
            if (source == "news") {
              this.project_detail.crawler.google.news_status = toggle;
            } else if (source == "media_cetak") {
              this.project_detail.crawler.formed.cetak_status = toggle;
            } else if (source == "media_tv") {
              if (toggle == 1) {
                this.media_tv_type = {
                  berita: true,
                  iklan: true,
                  running_text: true,
                };
              }
            }
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Channel berhasil diupdate.',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(() => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status channel.',
              position: "top",
              timeout: 4000,
              type: "danger",
            })
            .show();
        });
    },
    getMediaOnline: function(source = "news") {
      this.is_loading_media = true;
      this.media_online_list = [];

      this.total_medkon_list[source] = 0;
      this.selected_media[source] = [];

      let api = process.env.VUE_APP_API_URL + "media";
      let params = {};
      params["source"] = source;
      if (this.q[source]) {
        params["q"] = this.q[source];
        this.pagenumber[source] = 1;
      }
      params["page"] = this.pagenumber[source];
      params["items"] = 28;

      this.$http
        .get(api, { params: params })
        .then((response) => {
          if (response.status == 200) {
            this.media_online_list = response.data.list;
            this.total_medkon_list[source] = response.data.total;
            this.show_media[source] = this.media_online_list;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.is_loading_media = false;
        });
    },
    getMediaOnlineScroll: function(source = "news") {
      this.pagenumber[source] += 1;
      this.is_loading_media = true;
      let api = process.env.VUE_APP_API_URL + "media";
      let params = {
        source: source,
        page: this.pagenumber[source],
        items: 28,
      };
      if (this.q[source]) {
        params["q"] = this.q[source];
      }
      this.$http
        .get(api, { params: params })
        .then((response) => {
          if (response.status == 200) {
            this.media_online_list = response.data.list;
            this.total_medkon_list[source] = response.data.total;
            this.show_media[source].push.apply(
              this.show_media[source],
              this.media_online_list
            );
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.is_loading_media = false;
        });
    },
    mediaClicked: function(media, source) {
      if (this.selected_media[source].includes(media.nama)) {
        let index = this.selected_media[source].indexOf(media.nama);
        if (index !== -1) {
          this.selected_media[source].splice(index, 1);
        }
      } else {
        this.selected_media[source].push(media.nama);
      }
    },
    customMediaClicked: function(media, source) {
      if (this.selected_media[source].includes(media)) {
        let index = this.selected_media[source].indexOf(media);
        if (index !== -1) {
          this.selected_media[source].splice(index, 1);
        }
      } else {
        this.selected_media[source].push(media);
      }
    },
    saveMedia: function(source = "news") {
      this.is_loading_media = true;
      let api =
        process.env.VUE_APP_API_URL + "project/set-filter/" + this.id_project;
      let params = {
        source: source,
        list: this.selected_media[source],
      };
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Media berhasil disimpan.',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
            this.getChannelStatus();
          } else {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> ' +
                  response.data.status,
                position: "top",
                timeout: 5000,
                type: "warning",
              })
              .show();
          }
        })
        .catch((error) => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> ' +
                error.response.data.status,
              position: "top",
              timeout: 5000,
              type: "warning",
            })
            .show();
        })
        .finally(() => {
          this.is_loading_media = false;
          this.selected_media[source] = [];
        });
    },
    deleteAllFilterNews: function(tipe, source = "news") {
      let param_list = [];
      if (tipe == "selected") {
        param_list = this.selected_media[source];
      } else {
        param_list = this.medkon_filter[source];
      }
      let api =
        process.env.VUE_APP_API_URL +
        "project/delete-filter/" +
        this.id_project;
      let params = {
        source: source,
        list: param_list,
      };
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Media berhasil dihapus.',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
            this.getChannelStatus();
          } else {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> ' +
                  response.data.status,
                position: "top",
                timeout: 5000,
                type: "warning",
              })
              .show();
          }
        })
        .catch((error) => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> ' +
                error.response.data.status,
              position: "top",
              timeout: 5000,
              type: "warning",
            })
            .show();
        })
        .finally(() => {
          this.is_loading_media = false;
          this.selected_media[source] = [];
        });
    },
    onScroll: function({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.show_media.news.length < this.total_medkon_list.news) {
          this.getMediaOnlineScroll();
        }
      }
    },
    onScrollMediaCetak: function({
      target: { scrollTop, clientHeight, scrollHeight },
    }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (
          this.show_media.media_cetak.length <
          this.total_medkon_list.media_cetak
        ) {
          this.getMediaOnlineScroll("media_cetak");
        }
      }
    },
  },
  computed: {
    isAdmin: function() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2) {
        return true;
      }
      return false;
    },
  },
  mounted: function() {
    this.getMediaOnline();
    this.getMediaOnline("media_cetak");
    this.$.pgNotification = notif;
    this.getChannelStatus();
    let v_step = [];
    v_step[0] = {
      target: "#channel-medkon",
      header: {
        title: "Daftar Channel Media Konvensional.",
      },
      content: `Menampilkan Daftar Media Konvensional. Toggle Switch berfungsi untuk mengaktifkan atau menonaktikan media dari sistem. Toggle aktif (berwarna biru) berarti berita dari media tersebut akan ditampilkan, dan begitupun sebaliknya`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#channel-medsos",
      header: {
        title: "Daftar Channel Media Sosial",
      },
      content: `Menampilkan Daftar Media Sosial. Toggle Switch berfungsi untuk mengaktifkan atau menonaktikan media dari sistem. Toggle aktif (berwarna biru) berarti berita dari media tersebut akan ditampilkan, dan begitupun sebaliknya`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.selected {
  background-color: #fffde1;
}
.card {
  cursor: pointer;
}
.card:hover {
  background-color: #ffffff !important;
}
.medkon-list-wrapper {
  max-height: 400px;
  overflow-y: auto;
}
</style>
